import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { StrictMode } from "react";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/css/primeicons/primeicons.css";
import "../src/css/primereact/resources/themes/lara-light-cyan/theme.css";
import App from "./App";
import { msalConfig } from "./auth.config";
export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance
  .initialize()
  .then(() => {
    // Default to using the first account if no account is active on page load
    if (
      !msalInstance.getActiveAccount() &&
      msalInstance.getAllAccounts().length > 0
    ) {
      // Account selection logic is app dependent. Adjust as needed for different use cases.
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Optional - This will update account state if a user signs in from another tab or window
    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload;
        const { account } = payload;
        msalInstance.setActiveAccount(account);
        // rename below "TOKEN_KEY" key according to your app name in constant file
        // sessionStorage.setItem(TOKEN_KEY, payload.accessToken)
      }
    });
  })
  .then(() => msalInstance.handleRedirectPromise())
  .then(() => {

    const rootElement = document.getElementById("root");
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <StrictMode>
        <App msalInstance={msalInstance} />
      </StrictMode>
    );
  });


